import React from 'react';

import { flagStyles } from '../settings';

const SvgSY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5040px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSY;
